import { render, staticRenderFns } from "./ShipmentTraceCard.vue?vue&type=template&id=362bf11e&"
import script from "./ShipmentTraceCard.vue?vue&type=script&lang=js&"
export * from "./ShipmentTraceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports